export default "__VITE_ASSET__Dhd1pEUN__"